/** Lightweight skeleton while cached data loads — avoids blank flash */
export default function PageSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="h-48 md:h-64 bg-[#fff5f5]" />
      <div className="container-wide py-12 space-y-4">
        <div className="h-4 w-32 bg-zinc-200 rounded" />
        <div className="h-10 w-2/3 max-w-xl bg-zinc-200 rounded" />
        <div className="h-4 w-full max-w-2xl bg-zinc-100 rounded" />
        <div className="h-4 w-5/6 max-w-xl bg-zinc-100 rounded" />
      </div>
    </div>
  );
}
